import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-12 sm:pt-20 pb-10 sm:pb-16 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto overflow-hidden" data-id="element-27">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/8 rounded-full blur-[140px] -z-10 pointer-events-none" data-id="element-28" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="text-center space-y-8" data-id="element-29">
        <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-1.5 rounded-full bg-white/5 border border-white/10 text-xs sm:text-sm font-medium text-gray-300" data-id="element-30">
          <span className="w-2 h-2 rounded-full bg-primary animate-pulse" data-id="element-31" />
          El Código del Dinero: Inmersión Dropshipping Latam con IA
        </div>

        <h1 className="text-2xl sm:text-4xl lg:text-6xl font-extrabold tracking-tight text-white leading-[1.15]" data-id="element-32">
          Inicia Tu Tienda Online con IA Y Llevala A{' '}
          <span className="text-accent" data-id="element-33">$10,000 USD</span> En Ventas.... Sin
          Tener Que Invertir En Productos, Sin Encargarte De Almacenaje,
          Logística Y Envíos.
        </h1>

        <h2 className="text-base sm:text-xl lg:text-2xl text-gray-400 font-medium max-w-3xl mx-auto leading-relaxed" data-id="element-34">
          Mientras el 99% juega a ser "vendedor", nosotros activamos nuestra
          máquina de ventas. Estás a un solo producto de cambiar tu vida para
          siempre.
        </h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="relative max-w-4xl mx-auto mt-16 rounded-2xl overflow-hidden border border-primary/20 shadow-[0_0_60px_-15px_rgba(255,31,31,0.25)]" data-id="element-35">
          <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent z-10" data-id="element-36" />
          <img src="https://cdn.magicpatterns.com/uploads/uXB4Aq7rFU4Sh7t72Bc95q/Mejora_imagen_y_202604020141.jpg" alt="Lucas Torres - El Código del Dinero" className="w-full h-auto object-cover" data-id="element-37" />
        </motion.div>
      </motion.div>
    </section>;
}